import { useTranslation } from "react-i18next";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";

const WidgetTypeCard = (props) => {
  const { titleKey, descriptionKey, icon, installNowlink, learnmoreLink } =
    props;
  const { t } = useTranslation("coaching-portal");

  const handleRefresh = () => {
    submit(`/actions/refresh/`, {
      method: "GET",
      body: { section: "learn", learn: learnmoreLink },
    });
  };
  const openCreateWidgetModal = () => {
    submit(`/actions/refresh/`, {
      method: "GET",
      body: { modal: { type: "create-widget" }, type: learnmoreLink },
    });
  };
  return (
    <article
      className="widget-type-card"
      onClick={() => {
        handleRefresh();
      }}
    >
      <SvgIcon src={icon} noFilterOnLight={true} />
      <div>
        <p className="s2">{t(titleKey)}</p>
        <p className="p5">{t(descriptionKey)}</p>
      </div>

      <SvgIcon
        classNames={"learn-more-button"}
        src={"/img/new-icons/add.svg"}
        onClickFn={(e) => {
          e.stopPropagation();
          openCreateWidgetModal();
        }}
      />
    </article>
  );
};
const LearnWidgetsList = ({ widgetTypesList }) => {
  const { t } = useTranslation("coaching-portal");
  return (
    <aside className="mobile-hidden">
      <h4>{t("widgets.explore")}</h4>
      {widgetTypesList.map((w, i) => {
        return <WidgetTypeCard {...w} key={i} />;
      })}
    </aside>
  );
};
export default LearnWidgetsList;
